import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import Company, { CompanyLookup } from "models/company-details/company";
import {
  CompanyWorkgroup,
  CompanyWorkGroupWithPrivilege,
  WorkgroupPost,
} from "models/users/user-workgroups";
import { Observable } from "rxjs/Observable";
import CompanyLocation, {
  PagedCompanyLocation,
} from "../../models/company-details/company-location";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class CompanyManagementService {
  private companyUrl: string;
  private workgroupsUrl: string;
  private searchEndpoint: string;

  constructor(
    private httpClient: HttpClient,
    private http: HttpClient,
    private config: ConfigurationService
  ) {
    if (this.config.getConfig().isLocal) {
      this.companyUrl =
        config.getConfig().localEndpoints.companyServiceUrl + "/companies";
      this.workgroupsUrl =
        config.getConfig().localEndpoints.workgroups + "/companies";
    } else {
      this.companyUrl = config.getConfig().apiUrl + "/companies";
      this.workgroupsUrl = config.getConfig().apiUrl + "/users/companies";
    }
    this.searchEndpoint = this.companyUrl + "/search";
  }

  public CompanyLookupByName(
    name: string,
    companyId: string
  ): Observable<CompanyLookup[]> {
    return this.httpClient.get<CompanyLookup[]>(
      `${this.companyUrl}/lookup?name=${name}&companyId=${companyId}`
    );
  }

  public getCompany(id: string): Observable<Company> {
    return this.httpClient.get<Company>(`${this.companyUrl}/${id}`);
  }

  getCompanyList(request: any) {
    return this.http.post(this.searchEndpoint, request);
  }

  public createCompany(company: any): Observable<Company> {
    // const payload = CompanyDetails.toServicePaylod(company);
    return this.httpClient.post<Company>(`${this.companyUrl}`, company);
  }

  public updateCompany(company: Company): Observable<Company> {
    //const payload = CompanyDetails.toServicePaylod(company);
    return this.httpClient.put<Company>(
      `${this.companyUrl}/${company.companyId}`,
      company
    );
  }

  getCompanyLocations(request: any) {
    return this.http.post(this.searchEndpoint, request);
  }

  public listCompanyLocations(
    companyId: string,
    locationToken: string = ""
  ): Observable<PagedCompanyLocation> {
    return this.httpClient.get<PagedCompanyLocation>(
      `${this.companyUrl}/${companyId}/locations?lastToken=${locationToken}`
    );
  }

  public createLocation(companyId: string, location: CompanyLocation): any {
    return this.httpClient.post(
      `${this.companyUrl}/${companyId}/locations`,
      location
    );
  }

  public updateLocation(companyId: string, location: CompanyLocation): any {
    return this.httpClient.put(
      `${this.companyUrl}/${companyId}/locations/${location.locationId}`,
      location
    );
  }

  public getLocation(
    companyId: string,
    locationId: string
  ): Observable<CompanyLocation> {
    return this.httpClient.get<CompanyLocation>(
      `${this.companyUrl}/${companyId}/locations/${locationId}`
    );
  }

  public getWorkGroups(tenantId: number): Observable<CompanyWorkgroup[]> {
    return this.httpClient.get<CompanyWorkgroup[]>(
      `${this.workgroupsUrl}/${tenantId}/work-groups`
    );
  }

  public getWorkGroupById(
    tenantId: number,
    id: number
  ): Observable<CompanyWorkGroupWithPrivilege> {
    return this.httpClient.get<CompanyWorkGroupWithPrivilege>(
      `${this.workgroupsUrl}/${tenantId}/work-groups/${id}`
    );
  }

  public getWorkGroupPrivileges(
    tenantId: number
  ): Observable<CompanyWorkGroupWithPrivilege> {
    return this.httpClient.get<CompanyWorkGroupWithPrivilege>(
      `${this.workgroupsUrl}/${tenantId}/work-groups/privileges`
    );
  }

  public updateCompanyWorkgroup(
    tenantId: number,
    id: number,
    workgroup: WorkgroupPost
  ): Observable<any> {
    return this.httpClient.put(
      `${this.workgroupsUrl}/${tenantId}/work-groups/${id}`,
      workgroup
    );
  }

  public createCompanyWorkgroup(
    tenantId: number,
    workgroup: WorkgroupPost
  ): Observable<any> {
    return this.httpClient.post(
      `${this.workgroupsUrl}/${tenantId}/work-groups`,
      workgroup
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/company-management-service/company-management-service.ts